import React from 'react';
import {Card, ListGroup, ListGroupItem, CardGroup} from "react-bootstrap"
import './App.css';

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {word: "BACRONYM", letters: [], renderedWord: ""};
    }

    componentWillMount() {
        this.updateLetters();
    }

    handleTextChange(ev) {
        this.setState({word: ev.target.value});
    }

    updateLetters() {
        var _this = this;
        this.setState({renderedWord: this.state.word});
        fetch("https://www.jonbell.net/acronm-backend/search.php?keyword=" + this.state.word).then(
            (res) => {
                res.json().then(data => {
                    var selected = [];
                    data.letters.forEach((obj) => {
                        selected.push("")
                    });
                    _this.setState({letters: data.letters, selected: selected})
                });
            }
        );
    }

    updatePage(ev) {
        ev.preventDefault();
        this.updateLetters();
    }

    selectWord(obj, word, ev) {
        this.setState((prevState) => {
            let newSelected = prevState.selected.map((v, i) => (i == obj ? word : v));
            return {selected: newSelected};
        })
    }

    handleUpdateWord(obj, ev) {
        var val = ev.target.value;
        this.setState((prevState) => {
            let newSelected = prevState.selected.map((v, i) => (i == obj ? val : v));
            return {selected: newSelected};
        })
    }

    render() {
        let scrolled = {
            overflowY: "scroll",
            height: "75vh"
        }

        return (<div className="App">
                <div style={{textAlign:"center"}}>
                    <form onSubmit={this.updatePage.bind(this)}>
                        Acronym: <input type="text" value={this.state.word}
                                        onChange={this.handleTextChange.bind(this)}/>
                        <input type="submit" style={{border: '1px solid black', color:'black'}}/>
                    </form>
                </div>

                <CardGroup>
                {
                    this.state.letters.map((dat, i) => {
                        return <Card key={i}>
                            <input type="text" value={this.state.selected[i]}
                                   onChange={this.handleUpdateWord.bind(this, i)}/>
                            <div style={scrolled}>
                                <ListGroup variant="flush">
                                    {dat.words.map((word, j) => {
                                            return (<ListGroupItem key={j}
                                                active={word.toLowerCase() == this.state.selected[i].toLowerCase()}
                                                                   onClick={this.selectWord.bind(this, i, word)}>{word}</ListGroupItem>);
                                        }
                                    )}
                                </ListGroup>
                            </div>
                        </Card>
                    })
                }
                </CardGroup>
            </div>
        );
    }
}

export default App;
